// import { hpHttpClient } from 'root/api/http';
import { hpGqlClient } from 'root/api/';
import { crudActions } from 'root/store/helpers';
import { UserQuery } from './query';

const { create, filter, fetchMany, getById, update, deleteById } = hpGqlClient.user;

export const actions = {
  ...crudActions('user', {
    create, filter, fetchMany, getById, update, deleteById
  }, {
    queries: UserQuery,
  }),
};
